import {checkError, closeAlert, receiveErrorAlert} from "./commonsActions";
import {downloadGeoActivityCsv, getGeoActivity} from "../helpers/geoActivityService";


export const FETCH_GEO_ACTIVITY_BEGIN = 'FETCH_GEO_ACTIVITY_BEGIN';
export const FETCH_GEO_ACTIVITY_SUCCESS = 'FETCH_GEO_ACTIVITY_SUCCESS';
export const FETCH_GEO_ACTIVITY_ERROR = 'FETCH_GEO_ACTIVITY_ERROR';

/*
 * action creators
 */

const fetchGeoActivitySuccess = res => ({
    type: FETCH_GEO_ACTIVITY_SUCCESS,
    payload: {
        geoActivity: res.data,
        numberOfElements: res.numberOfElements,
        totalElements: res.totalElements,
        totalPages: res.totalPages
    }
});

const fetchGeoActivityError = error => ({
    type: FETCH_GEO_ACTIVITY_ERROR,
    payload: {
        error: error,
    }
});

export const fetchGeoActivity = query => dispatch => {
    dispatch({type: FETCH_GEO_ACTIVITY_BEGIN});
    return getGeoActivity(query).then(res => {
        dispatch(fetchGeoActivitySuccess(res));
        return res;
    }, error => {
        dispatch(fetchGeoActivityError(error))
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};

export const fetchGeoActivityCsv = query => dispatch => {
    return downloadGeoActivityCsv(query).then(res => {
        return res;
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};


// WEBPACK FOOTER //
// ./src/actions/geoActivityActions.js